// base=/etc/designs/header/clientlibs/responsive/js

/*
 * Responsive Header
 *  - everything in this clientlib is needed only for the Responsive Header
 *
 * Header Modules used by header/footer:
 *  modBasket
 *  modFlatButton
 *  modFlyout
 *  modHeader
 *  modFooter
 *  modImageAnimation
 *  modMetanav
 *  modSiteSearch
 *  modSiteSearch.skinSiteSearchMobileMenu
 *  modProductComparator
 */

import 'etc/designs/ecommerce/clientlibs/shared/js/userbox.js';
import 'etc/designs/ecommerce/clientlibs/shared/js/res-sme-cbu-popup.js';

// -----------------------------------------------------------------------------
// TERRIFIC MODULES
// -----------------------------------------------------------------------------

import 'etc/designs/header/clientlibs/responsive/js/modules/Tc.Module.Basket.js';
import 'etc/designs/header/clientlibs/responsive/js/modules/Tc.Module.Flyout.js';
import 'etc/designs/header/clientlibs/responsive/js/modules/Tc.Module.Footer.js';
import 'etc/designs/header/clientlibs/responsive/js/modules/Tc.Module.Header.js';
import 'etc/designs/header/clientlibs/responsive/js/modules/Tc.Module.ProductComparator.js';
import 'etc/designs/header/clientlibs/responsive/js/modules/Tc.Module.SiteSearch.js';
import 'etc/designs/header/clientlibs/responsive/js/modules/Tc.Module.SiteSearch.MobileMenu.js';
import 'etc/designs/header/clientlibs/responsive/js/modules/Tc.Module.Metanav.js';

// Modern modules (using imports/exports)
import FusionSearch from 'lib/search/Tc.Module.FusionSearch';
import ImageAnimation from 'lib/generic/header/Tc.Module.ImageAnimation';

const modernTcModules = {
	FusionSearch,
	ImageAnimation,
};
// Tc Bootstrap
import { legacyBootstrapDeferredSingleton } from 'bootstrap/load-terrific';
legacyBootstrapDeferredSingleton(modernTcModules);

// -----------------------------------------------------------------------------
// SWISSCOM CODE
// -----------------------------------------------------------------------------

import 'etc/designs/header/clientlibs/responsive/js/sitecatalyst.js';



// WEBPACK FOOTER //
// typescript://../clientlibs/js/by-category/scs.header.responsive.ts